import {useContext} from 'preact/hooks';

import {LocationContextImpl} from './context';

export function useLocation() {
  return useContext(LocationContextImpl);
}
